import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useContent } from "@/context/ContentContext";
import { useFavorites } from "@/context/FavoritesContext";
import { ServiceCard } from "@/components/shared/ServiceCard";
import { OrderModal } from "@/components/shared/OrderModal";
import { PageHeader } from "@/components/shared/DashKit";
import { Loader2, Heart } from "lucide-react";

export default function Favorites() {
  const { t } = useContent();
  const fav = useFavorites();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [service, setService] = useState(null);
  const [open, setOpen] = useState(false);

  const load = () => api.get("/favorites").then((r) => { setItems(r.data.items || []); setLoading(false); });
  useEffect(() => { load(); }, []);
  // Keep the list in sync when a favorite is removed from a card.
  useEffect(() => { if (fav) setItems((prev) => prev.filter((s) => fav.ids.has(s.id))); }, [fav?.ids]); // eslint-disable-line

  return (
    <div>
      <PageHeader title={t("client.fav.title", "Mes favoris")} subtitle={t("client.fav.subtitle", "Retrouvez vos services favoris et commandez en un clic.")} />
      {loading ? (
        <div className="py-16 text-center"><Loader2 className="mx-auto h-6 w-6 animate-spin text-accent" /></div>
      ) : items.length === 0 ? (
        <div className="flex flex-col items-center gap-2 rounded-2xl border border-dashed border-border p-14 text-center text-muted-foreground" data-testid="favorites-empty">
          <Heart className="h-7 w-7" /> {t("client.fav.empty", "Aucun favori pour le moment. Ajoutez des services depuis le catalogue.")}
        </div>
      ) : (
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-testid="favorites-grid">
          {items.map((s) => <ServiceCard key={s.id} service={s} onOrder={(sv) => { setService(sv); setOpen(true); }} />)}
        </div>
      )}
      <OrderModal service={service} open={open} onClose={() => setOpen(false)} />
    </div>
  );
}
